<!--
    Params
      - node - node to edit
-->

<template>
  <ValidationObserver
    ref="flowNodeObserver"
    v-slot="{ valid }" >
    <b-modal
      ref="addFlowNode"
      size="lg"
      :modal-class="['node-modal', { white: !addType}]"
      :body-class="{ 'dark-background': addType }"
      centered
      :hide-footer="!addType"
      @hidden="reset" >
      <!-- HEADER slot -->
      <template slot="modal-header">
        <Vnodes
          :vnodes="title" />

        <SBIcon
          class="close-btn"
          :icon="SBIconList.CLOSE_THIN"
          :color="SBColors.white"
          background-color="#bdc8cd"
          :hover-color="SBColors.blackPrimary"
          :border-color="SBColors.blackPrimary"
          :pointer="true"
          :size="5"
          :hover-size="15"
          :border-radius="50"
          @click="hide" />
      </template>

      <!-- FOOTER slot -->
      <template slot="modal-footer">
        <div class="modal-footer__buttons flex flex-row flex-nowrap">
          <b-button
            :disabled="working"
            @click="hide" >Cancel</b-button>
          <b-button
            class=""
            :disabled="!valid || working"
            variant="primary"
            :class="{ loading: working }"
            @click="confirm" >
            <span>Save</span>
            <Spinner
              v-if="working"
              class="absolute"
              :size="14"
              :thickness="2"
              :color="SBColors.white" />
          </b-button>
        </div>
      </template>

      <!-- Type selector -->
      <div v-if="!addType">
        <h2>Actions</h2>
        <div class="row">
          <!-- <div
            class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0"
            :class="{ disabled: maxBlocksUsed || blockAiAssistant }"
            @click="addNewNode('aiAssistant')" >
            <img
              :src="getIconUrl('aiAssistant')"
              class="mr-2" >
            <div class="flex flex-column">
              <h3>Assign AI assistant</h3>
              <p>Assign AI to communicate with customers</p>
            </div>
          </div>
          <div
            class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0"
            :class="{ disabled: maxBlocksUsed }"
            @click="addNewNode('message')" >
            <img
              :src="getIconUrl('message')"
              class="mr-2" >
            <div class="flex flex-column">
              <h3>Send message</h3>
              <p>Send a session message to the contact</p>
            </div>
          </div> -->
          <!-- <div class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0">
            <SBIcon
              id="template-message-btn"
              class="mr-2"
              :icon="SBIconList.WHATSAPP_LOGO"
              :color="SBColors.blackUltralight"
              :mask-hover="false"
              :size="16" />
            <div class="flex flex-column">
              <h3>Send message</h3>
              <p>Send a session message to the contact</p>
            </div>
          </div>
          <div class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0">
            <SBIcon
              id="template-message-btn"
              class="mr-2"
              :icon="SBIconList.WHATSAPP_LOGO"
              :color="SBColors.blackUltralight"
              :mask-hover="false"
              :size="16" />
            <div class="flex flex-column">
              <h3>Send message</h3>
              <p>Send a session message to the contact</p>
            </div>
          </div> -->
          
          <div
            class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0"
            :class="{ disabled: maxBlocksUsed || blockAiAssistant }"
            @click="addNewNode('aiAssistant')" >
            <img
              :src="getIconUrl('aiAssistant')"
              class="mr-2" >
            <div class="flex flex-column">
              <h3>{{ ASSAITOCONV.meta.name }}</h3>
              <p>{{ ASSAITOCONV.meta.description }}</p>
            </div>
          </div>
          <div
            class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0"
            :class="{ disabled: maxBlocksUsed }"
            @click="addNewNode('message')" >
            <img
              :src="getIconUrl('message')"
              class="mr-2" >
            <div class="flex flex-column">
              <h3>{{ SENDWAMSG.meta.name }}</h3>
              <p>{{ SENDWAMSG.meta.description }}</p>
            </div>
          </div>
        </div>

        <h2>Logic</h2>
        <div class="row">
          <div
            class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0"
            :class="{ disabled: maxBlocksUsed }"
            @click="addNewNode('filter')" >
            <img
              :src="getIconUrl('filter')"
              class="mr-2" >
            <div class="flex flex-column">
              <h3>{{ FILTER.meta.name }}</h3>
              <p>{{ FILTER.meta.description }}</p>
            </div>
          </div>
          <div
            class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0"
            :class="{ disabled: maxBlocksUsed }"
            @click="addNewNode('reply')" >
            <img
              :src="getIconUrl('reply')"
              class="mr-2" >
            <div class="flex flex-column">
              <h3>{{ CONREP.meta.name }}</h3>
              <p>{{ CONREP.meta.description }}</p>
            </div>
          </div>
          <div
            class="action-item flex justify-start flex-align-center col-12 col-lg-6 p-0"
            :class="{ disabled: blockSplit || maxSplitBlocksUsed || maxBlocksUsed }"
            @click="addNewNode('split')" >
            <img
              :src="getIconUrl('split')"
              class="mr-2" >
            <div class="flex flex-column">
              <h3>{{ SPLIT.meta.name }}</h3>
              <p>{{ SPLIT.meta.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Specific element -->
      <SendMessageBlock
        v-if="addType === 'message'"
        ref="sendMessageBlockRef"
        :node="node"
        :edit-mode="editMode"
        @finished="hide" />
      <FilterBlock
        v-if="addType === 'filter'"
        ref="filterBlockRef"
        :node="node"
        :edit-mode="editMode"
        @finished="hide" />
      <ContactReply
        v-if="addType === 'reply'"
        ref="replyBlockRef"
        :node="node"
        :edit-mode="editMode"
        @finished="hide" />
      <Split
        v-if="addType === 'split'"
        ref="splitBlockRef"
        :node="node"
        @finished="hide" />
      <AiAssistant
        v-if="addType === 'aiAssistant'"
        ref="aiAssistantBlockRef"
        :node="node"
        :edit-mode="editMode"
        @finished="hide" />
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SendMessageBlock from '@/components/business/flows/blocks/SendMessage';
import FilterBlock from '@/components/business/flows/blocks/FilterBlock';
import ContactReply from '@/components/business/flows/blocks/ContactReply';
import Split from '@/components/business/flows/blocks/Split';
import AiAssistant from '@/components/business/flows/blocks/AiAssistant';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'AddFlowNodeModal',
  components: {
    SBIcon,
    SendMessageBlock,
    FilterBlock,
    ContactReply,
    Split,
    AiAssistant,
    Vnodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      node: null,
      editMode: false,
      addType: null,
      working: false,
      sibling: null,
      targetNodeId: null,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      flowsDefinitionsUI: 'flows/flowsDefinitionsUI', // TODO delete
      flowsDefinitions: 'flows/flowsDefinitions',
      newTemplateConfig: 'notification/newTemplateConfig',
      updatingFlow: 'flows/updatingFlow',
      blocksCount: 'flows/blocksCount',
    }),
    blockAiAssistant() {
      if (!this.flowsDefinitions.blocks) return false;
      const targetTypeDefinition = this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'ASSAITOCONV');
      return targetTypeDefinition.definition.limits && targetTypeDefinition.definition.limits.is_last_block_in_flow && this.node && this.node.children.length ? targetTypeDefinition.definition.limits.is_last_block_in_flow : false;
    },
    blockSplit() {
      if (!this.flowsDefinitions.blocks) return false;
      const targetTypeDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'SPLIT');
      return targetTypeDefinition.definition.limits && targetTypeDefinition.definition.limits.is_last_block_in_flow && this.node && this.node.children.length ? targetTypeDefinition.definition.limits.is_last_block_in_flow : false;
    },
    maxBlocksUsed() {
      // -1 because we are not counting trigger block
      return this.flowsDefinitions && this.flowsDefinitions.flows && (this.blocksCount.total - 1) >= this.flowsDefinitions.flows.rules.BLOCKS_PER_FLOW;
    },
    maxSplitBlocksUsed() {
      return this.flowsDefinitions && this.flowsDefinitions.flows && this.blocksCount.split >= this.flowsDefinitions.flows.rules.SPLIT_BLOCKS_PER_FLOW;
    },
    SENDWAMSG() {
      return this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'SENDWAMSG');
    },
    ASSAITOCONV() {
      return this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'ASSAITOCONV');
    },
    FILTER() {
      return this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
    },
    CONREP() {
      return this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'CONREP');
    },
    SPLIT() {
      return this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'SPLIT');
    },
    title() {
      const h = this.$createElement;
      let title = h('h2', { class: 'show-arrow' }, 'Add new block');
      let titleText = 'block';
      let icon = '';
      let targetTypeDefinition;
      switch (this.addType) {
        case 'message':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'SENDWAMSG');
          icon = targetTypeDefinition.definition.icons.dark;
          titleText = 'Send message';
          break;
        case 'aiAssistant':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'ASSAITOCONV');
          icon = targetTypeDefinition.definition.icons.dark;
          titleText = 'Assign AI assistant';
          break;
        case 'filter':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
          icon = targetTypeDefinition.definition.icons.dark;
          titleText = 'Filter';
          break;
        case 'reply':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'CONREP');
          icon = targetTypeDefinition.definition.icons.dark;
          titleText = 'Contact reply';
          break;
        case 'split':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'SPLIT');
          icon = targetTypeDefinition.definition.icons.dark;
          titleText = 'Split';
          break;
        default:
          titleText = `${this.editMode ? 'Edit' : 'Add new'} block`;
          break;
      }
      if (this.addType) {
        title = h(
          'h2',
          {
            class: 'flex center-all show-hand',
            on: {
              click: () => {
                this.addType = null;
              },
            },
          },
          [
            h(
              'SBIcon',
              {
                props: {
                  icon: SBIconList.DOWN_ARROW,
                  color: this.SBColors.blackUltralight,
                  size: 12,
                },
                class: 'rotate-90',
              },
            ),
            icon ? h(
              'img',
              {
                attrs: {
                  src: icon,
                  alt: '',
                },
                style: {
                  width: '16px',
                  height: '16px',
                },
              },
            ) : '',
            `${titleText}`,
          ],
        );
      }
      return title;
    },
  },
  beforeMount() {
    this.$eventBus.$on('addNodeModal', (params) => {
      if (!this.updatingFlow) {
        this.show(params);
      } else {
        this.showToaster(`Wait for the flow to update before ${params.mode === 'edit' ? 'editing' : 'adding'} a block.`, null, null, 'warning');
      }
    });
  },
  methods: {
    ...mapActions({
      loadNewTemplateConfig: 'notification/loadNewTemplateConfig',
    }),
    getIconUrl(type) {
      if (!this.flowsDefinitions || !this.flowsDefinitions.blocks || !this.flowsDefinitions.blocks.definitions) {
        return '';
      }

      let icon = '';
      let targetTypeDefinition;
      switch (type) {
        case 'message':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'SENDWAMSG');
          icon = targetTypeDefinition.definition.icons.dark;
          break;
        case 'aiAssistant':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'ASSAITOCONV');
          icon = targetTypeDefinition.definition.icons.dark;
          break;
        case 'filter':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
          icon = targetTypeDefinition.definition.icons.dark;
          break;
        case 'reply':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'CONREP');
          icon = targetTypeDefinition.definition.icons.dark;
          break;
        case 'split':
          targetTypeDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'SPLIT');
          icon = targetTypeDefinition.definition.icons.dark;
          break;
        default:
          break;
      }

      return icon;
    },
    show(params) {
      if (this.emptyObject(this.newTemplateConfig)) {
        this.loadNewTemplateConfig(this.businessId).then((response) => {
          if (response.status === 200) {}
        });
      }
      if (params.node) {
        this.node = params.node;
      }
      this.editMode = params.mode && params.mode === 'edit';
      if (params.forceType) {
        switch (params.forceType.toUpperCase()) {
          case 'SENDWAMSG':
            this.addType = 'message';
            break;
          case 'FILTER':
            this.addType = 'filter';
            break;
          case 'CONREP':
            this.addType = 'reply';
            break;
          case 'ASSAITOCONV':
            this.addType = 'aiAssistant';
            break;
          default:
            this.addType = null;
            break;
        }
      }
      this.sibling = params.sibling || null;
      this.targetNodeId = params.targetNodeId;
      this.$refs.addFlowNode.show();
    },
    hide() {
      this.$refs.addFlowNode.hide();
    },
    addNewNode(type) {
      if (this.maxBlocksUsed) {
        this.showToaster(`You can add up to ${this.flowsDefinitions.flows.rules.BLOCKS_PER_FLOW} blocks.`, null, null, 'warning');
        return;
      }
      if (type === 'split' && this.maxSplitBlocksUsed) {
        this.showToaster(`You can add up to ${this.flowsDefinitions.flows.rules.SPLIT_BLOCKS_PER_FLOW} Split blocks.`, null, null, 'warning');
        return;
      }
      if (type === 'split' && this.blockSplit) {
        this.showToaster('Split can only be added as the last block.', null, null, 'warning');
        return;
      }
      if (type === 'aiAssistant' && this.blockAiAssistant) {
        this.showToaster('Assign AI assistant can only be added as the last block.', null, null, 'warning');
        return;
      }
      this.addType = type;
    },
    reset() {
      this.node = null;
      this.addType = null;
    },
    confirm() {
      if (this.addType === 'message') {
        this.$refs.sendMessageBlockRef.submit(this.node.id);
      } else if (this.addType === 'filter') {
        this.$refs.filterBlockRef.submit(this.node.id, this.sibling, this.targetNodeId);
      } else if (this.addType === 'reply') {
        this.$refs.replyBlockRef.submit(this.node.id);
      } else if (this.addType === 'split') {
        this.$refs.splitBlockRef.submit(this.node.id);
      } else if (this.addType === 'aiAssistant') {
        this.$refs.aiAssistantBlockRef.submit(this.node.id);
      }
      // Modal hides and skeleton is shown until the action is finished and block gets an id
      this.hide();
    },
  },
};
</script>

<style lang="scss">
.node-modal {
  .modal-dialog {
    max-width: 90%;
    width: 630px;
  }

  .modal-content {
    .modal-header {
      padding: 20px;
      box-shadow: none;
      border-bottom: solid 1px $greyBorderModal;
      display: flex;
      flex-direction: column;

      .close-btn {
        position: absolute;
        top: 23px;
        right: 20px;
      }

      h2 {
        font-size: 16px;
        font-weight: 500 !important;
        color: $blackPrimary;
        margin-bottom: 0px;
        gap: 10px;

        &:hover {
          .sb-icon {
            .mask {
              background-color: $blackPrimary !important;
            }
          }
        }
      }

      p {
        font-size: 14px;
        color: $blackUltralight;
      }
    }
    .modal-body {
      padding: 20px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      color: $blackPrimary;
      background-color: $white !important;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

      &.dark-background {
        background-color: #F8FAFB !important;
      }

      h2 {
        font-size: 14px !important;
        font-weight: 500 !important;
        margin-bottom: 10px;
      }

      .row {
        gap: 10px;
        margin-right: 0px;
        margin-left: 0px;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0px;
        }
      }

      .action-item {
        cursor: pointer !important;
        padding: 10px !important;
        border: dashed 1px $greyBorderModal;
        border-radius: 10px;
        &:nth-child(2n + 1),
        &:nth-child(2n + 2) {
          flex: 0 0 calc(50% - 5px);
        }

        &.red {
          border-color: red;
        }

        img {
          width: 18px;
          height: 18px;
        }

        h3 {
          font-weight: 500;
          font-size: 14px;
        }
        p {
          font-size: 11px;
          color: $blackUltralight;
        }

        &.disabled {
          cursor: default !important;
          filter: grayscale(1) opacity(0.7);
        }

        &:not(.disabled):hover {
          background-color: $greyUltralight;
        }
      }
    }
  }
}
</style>
